import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@mui/material";
import { getTimeOnlyString } from "../helpers/weather-helpers";
import { faDroplet, faDropletSlash } from "@fortawesome/free-solid-svg-icons";
import { HourlyWeather, HourlyWeatherUnit } from "../types/Weather";

const WeatherPrecipatationSection = ({ hourlyWeather, hourlyWeatherUnit }: {
  hourlyWeather: HourlyWeather[]
  hourlyWeatherUnit: HourlyWeatherUnit,
}) => {
  return (
    <Box sx={{ paddingY: 4 }}>
      <Typography variant="body1" sx={{ fontWeight: '600' }}>Precipitation</Typography>
      <Box sx={{ display: 'flex', overflowX: 'scroll' }}>
        {
          hourlyWeather.map((eachHour) => {
            return (
              <Box sx={{ flexBasis: '10px', flexShrink: 0, paddingY: 2, paddingX: 2, textAlign: 'center' }} key={eachHour.time}>
                <Typography>{eachHour.precipitation_probability}{hourlyWeatherUnit?.precipitation_probability}</Typography>
                <div>
                  <FontAwesomeIcon
                    style={{ paddingTop: 12, paddingBottom: 5 }}
                    icon={eachHour.precipitation_probability ? faDroplet : faDropletSlash}
                    size="1x" />
                </div>
                <Typography variant="caption">{getTimeOnlyString(eachHour.time)}</Typography>
              </Box>
            )
          })
        }
      </Box>
    </Box>
  );
}

export default WeatherPrecipatationSection;